/**
 * @generated SignedSource<<987375b40b304638151397d3ea0e730f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAddToCartButton_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAddItemToCart_item">;
  readonly " $fragmentType": "PdpSharedAddToCartButton_item";
};
export type PdpSharedAddToCartButton_item$key = {
  readonly " $data"?: PdpSharedAddToCartButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAddToCartButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAddItemToCart_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a8ac3b8ebbb7971e1c3e26968d2342b3";

export default node;
